module.exports = __webpack_public_path__ + "media/images/icons/exclamationmark-circle-disabled-b772d0ddca585bd98ea9259daba2c5ef.svg";